import { getContentValue } from '@truqc/content-path';
import store from '../reducers/storeRegistration';
const isFormCachePath = name => {
  if (typeof name !== 'string') {
    return false;
  }
  const n = name.replace(/\\/g, '/');
  return n === 'formCache' || n.startsWith('formCache/');
};
const valueOrUndefinedForOverview = (name, value) => {
  if ((value === null || value === void 0 ? void 0 : value.overview) === true && isFormCachePath(name)) {
    return undefined;
  }
  return value;
};

/**
 * this returns localy (client specific) cached variables.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const name = await evaluateSource(source.name, content, parentContentPath, transientContext, nativeFunctions);
  const state = store.getState();
  const _state$entityName$edi = state[entityName].editorCache,
    editorCache = _state$entityName$edi === void 0 ? {} : _state$entityName$edi;
  const raw = getContentValue(name, editorCache);
  return valueOrUndefinedForOverview(name, raw);
};
export default {
  evaluate
};